export function Showcase() {
    const screenshots = [
        { src: "/screenshots/home_snack_screenshot.jpg", label: "Catalogue produits", alt: "Page d'accueil — Catégories de produits" },
        { src: "/screenshots/cart_screenshot.png", label: "Panier détaillé", alt: "Panier de commande avec détails personnalisés" },
        { src: "/screenshots/stripe_checkout_screenshot.png", label: "Paiement sécurisé", alt: "Paiement sécurisé Stripe" },
        { src: "/screenshots/paiement_success_screenshit.png", label: "Confirmation commande", alt: "Confirmation de commande payée" },
        { src: "/screenshots/coupon_screenshot.png", label: "Coupon fidélité", alt: "Email de coupon de fidélité" },
    ];

    return (
        <section className="py-12 px-6 bg-gradient-to-br from-slate-900 to-[#1e3a5f] text-white overflow-hidden" id="apercu">
            <div className="text-center mb-12">
                <h2 className="text-[clamp(1.75rem,4vw,2.75rem)] font-extrabold text-white leading-[1.2] tracking-tight mb-4">
                    Découvrez l'application en images.
                </h2>
                <p className="text-[clamp(1.05rem,2vw,1.25rem)] text-slate-400 max-w-[680px] mx-auto leading-relaxed">
                    De vrais écrans, de vraies commandes. Voici ce que vos clients et vous verrez au quotidien.
                </p>
            </div>
            <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-5 gap-6 max-w-[1200px] mx-auto items-start">
                {screenshots.map(s => (
                    <div key={s.label} className="text-center">
                        <div className="relative inline-block rounded-[32px] overflow-hidden bg-slate-900 p-2.5 shadow-xl w-full max-w-[220px] mx-auto mb-4 transition-transform hover:-translate-y-2 hover:scale-[1.03]">
                            <img src={s.src} alt={s.alt} className="block rounded-3xl w-full h-auto" width={360} height={780} loading="lazy" />
                        </div>
                        <div className="text-[0.9rem] font-semibold text-white/85 mt-3">{s.label}</div>
                    </div>
                ))}
            </div>
        </section>
    );
}
